/* eslint-disable jsx-a11y/anchor-is-valid */
import { CaretDownOutlined } from "@ant-design/icons";
import { Button, Dropdown, List, Space } from "antd";
import React, { useEffect, useState } from "react";
import InspectionHeader from "../InspectionHeader";
import CopyToTemplate from "./components/CopyToTemplate";
import ItemsList from "./components/ItemsList";
import PrintInspection from "./components/PrintInspection";
import ShareWithOwners from "./components/ShareWithOwners";
import ShareWithTenants from "./components/ShareWithTenants";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { useParams } from "react-router-dom";

const InspectionItemPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false);
  const [isShareWithOwnerModalVisible, setIsShareWithOwnerModalVisible] =
    useState(false);
  const [isShareWithTenantModalVisible, setIsShareWithTenantModalVisible] =
    useState(false);
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);

  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [iInspectionFetched, setInspectionFetched] = useState(false);
  const [inspectionDetail, setInspectionDetail] = useState();
  const [propertiesDetail, setPropertiesDetail] = useState();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const { id } = useParams();

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchInspections = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "inspections");

        const docSnapshot = await getDoc(doc(userRef, id));

        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          setInspectionDetail(data);
          setInspectionFetched(true);
        } else {
          console.log("No inspection found with the specified ID.");
        }
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    };
    fetchInspections();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!iInspectionFetched) return;
    const fetchInspections = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "properties");
        const docSnapshot = await getDoc(
          doc(userRef, inspectionDetail?.inspectionAddress)
        );

        if (docSnapshot.exists()) {
          const propertyData = docSnapshot.data();
          setPropertiesDetail([propertyData]);
          setInspectionFetched(true);
        } else {
          console.log("No inspection found with the specified ID.");
        }
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    };
    fetchInspections();
  }, [companyName, isCompanyNameFetched, iInspectionFetched]);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const showPrintInspectionModal = () => {
    setIsPrintModalVisible(true);
  };

  const handlePrintModalCancel = () => {
    setIsPrintModalVisible(false);
  };

  const handlePrintModalOk = () => {
    setIsModalVisible(false);
  };
  const showShareWithOwnerModal = () => {
    setIsShareWithOwnerModalVisible(true);
  };

  const handleShareWithOwnerModalCancel = () => {
    setIsShareWithOwnerModalVisible(false);
  };

  const handleShareWithOwnerModalOk = () => {
    setIsShareWithOwnerModalVisible(false);
  };

  const showShareWithTenantModal = () => {
    setIsShareWithTenantModalVisible(true);
  };

  const handleShareWithTenantModalCancel = () => {
    setIsShareWithTenantModalVisible(false);
  };

  const handleShareWithTenantModalOk = () => {
    setIsShareWithTenantModalVisible(false);
  };

  const showCopyModal = () => {
    setIsCopyModalVisible(true);
  };

  const handleCopyModalCancel = () => {
    setIsCopyModalVisible(false);
  };

  const handleCopyModalOk = () => {
    setIsCopyModalVisible(false);
  };

  const items = [
    {
      label: (
        <a href="#" onClick={showModal}>
          Create Work Order
        </a>
      ),
      key: "0",
    },
    {
      label: (
        <a href="#" onClick={showPrintInspectionModal}>
          Print Inspection
        </a>
      ),
      key: "1",
    },
    {
      label: (
        <a href="#" onClick={showShareWithOwnerModal}>
          Share with Owners
        </a>
      ),
      key: "2",
    },
    {
      label: (
        <a href="#" onClick={showShareWithTenantModal}>
          Share with Tenants
        </a>
      ),
      key: "3",
    },
    {
      label: (
        <a href="#" onClick={showCopyModal}>
          Copy to Template
        </a>
      ),
      key: "4",
    },
  ];
  return (
    <>
      {isCompanyNameFetched ? (
        <div className="InspectionItemPage">
          <InspectionHeader
            companyName={companyName}
            inspectionDetail={inspectionDetail}
          />
          <List
            dataSource={propertiesDetail}
            renderItem={(item) => (
              <List.Item key={item?.propertyNameAddress?.propertyName}>
                <List.Item.Meta
                  title={
                    <p>Property: {item?.propertyNameAddress?.propertyName}</p>
                  }
                />
                <div>
                  <Dropdown
                    menu={{
                      items,
                    }}
                    trigger={["click"]}
                    style={{ width: "20%" }}
                  >
                    <Button onClick={(e) => e.preventDefault()}>
                      <Space>
                        Actions
                        <CaretDownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </div>
              </List.Item>
            )}
          />

            <ItemsList
              companyName={companyName}
              isCompanyNameFetched={isCompanyNameFetched}
              isModalVisible={isModalVisible}
              handleCancel={handleCancel}
              handleOk={handleOk}
            />

          <PrintInspection
            isModalVisible={isPrintModalVisible}
            handleCancel={handlePrintModalCancel}
            handleOk={handlePrintModalOk}
          />

          <ShareWithOwners
            isModalVisible={isShareWithOwnerModalVisible}
            handleCancel={handleShareWithOwnerModalCancel}
            handleOk={handleShareWithOwnerModalOk}
          />

          <ShareWithTenants
            isModalVisible={isShareWithTenantModalVisible}
            handleCancel={handleShareWithTenantModalCancel}
            handleOk={handleShareWithTenantModalOk}
          />

          <CopyToTemplate
            isModalVisible={isCopyModalVisible}
            handleCancel={handleCopyModalCancel}
            handleOk={handleCopyModalOk}
          />
        </div>
      ) : null}
    </>
  );
};

export default InspectionItemPage;
